import React from 'react';
import {PaymentItems} from "./payment-items/payment-items";
import {useAppDispatch, useAppSelector} from "common/hook";
import {PaymentItem} from "features/model/types/payments/paymentsSchema";
import {Preloader} from "../../../layout/preloader/Preloader";
import {NothingYetMessage} from "../../personal-cabinet/nothing-yet-message/NothingYetMessage";
import {CustomPagination} from "../../../pagination/CustomPagination";
import {fetchPayments} from "features/model/service/payments/payments";


export const PaymentTable = () => {
    const dispatch = useAppDispatch();
    const paymentsState = useAppSelector((state) => state.payments);
    const {payments, pagination, error, isLoading} = paymentsState;

    const {pageSize,pageCount,page} = pagination


    const onChangeHandle = (event: React.ChangeEvent<unknown>, value: number) => {
        dispatch(fetchPayments({page: value -1}));
    };


    return (
        <div className="data-tbl payments-tbl has-delete">
            {isLoading ? (
                <Preloader/>
            ) : (
                payments && payments.length > 0 ? (
                    payments.map((payment: PaymentItem) => (
                        <PaymentItems payment={payment} key={payment.id}/>
                    ))
                ) : (
                    <NothingYetMessage/>
                )
            )}
                {pageCount > 1 && (
                    <CustomPagination pageCount={pageCount} onChangeHandle={onChangeHandle} />
                )}
        </div>
    )
}





